import { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { ENDPOINTS } from '../../../Utils/Endpoints';
import { Models } from '../../../Utils/ModelsSeguridad';
import RecursosModal from '../Recursos/RecursosModal';
import { iconToFA } from '../../../../../utils/iconHelpers';
import MenuReorderModal from './MenuReorderModal';
import AlertDialog from '../../../../Lms/Components/Shared/AlertDialog';

const EMPTY = {
  idMenu: 0,
  idModulo: 0,
  nombre: '',
  clave: 'Catalog.jsx',
  // nivel fijo en 1, ya no se edita en UI
  nivel: 1,
  idPadre: 0,
  orden: 1,
  ruta: '../Modulo/Components/Catalogos/Carpeta/',
  icono: 'lucide:perfil',
  idRecurso: 0,
  esRaizModulo: false,
};

const endpointMenus = ENDPOINTS.menus;
const endpointModulos = ENDPOINTS.modulos;
const endpointRecursos = ENDPOINTS.recursos;

// 👇 helper para convertir a PascalCase / UpperCamelCase
function toPascalCase(str) {
  if (!str) return '';
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')        // quitar acentos
    .replace(/[^a-zA-Z0-9]+/g, ' ')        // separar por espacios cualquier no alfanumérico
    .trim()
    .split(/\s+/)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join('');
}
// Entradas especiales fijas
const STATIC_CATALOG_PATHS = [
  { label: 'Navegación: /navigate', value: '/navigate' },
  { label: 'Relativo: ../', value: '../' },
];

const catalogModules = require.context(
  '../../../../',
  true,
  /(Components|RH\/Components)\/(Catalogos|Gestion)\/[^/]+\/[^/]*(Catalog|Matrix|Page)\.jsx$/
);

// Segunda descubrimiento más amplio para el campo Clave
const componentFiles = require.context(
  '../../../../',
  true,
  /.*(Catalog|Matrix|Page)\.(jsx|tsx)$/
);

const uniquePaths = new Set();
const AUTO_CATALOG_PATHS = [];

catalogModules.keys().forEach((key) => {
  // key se ve como './Lms/Components/Catalogos/Cursos/CursosCatalog.jsx'
  const clean = key.replace(/^\.\//, ''); // 'Lms/Components/Catalogos/Cursos/CursosCatalog.jsx'
  const parts = clean.split('/');

  const modulo = parts[0] || '';
  const carpeta = parts[parts.length - 2] || '';

  // Ruta de carpeta sin el nombre del archivo
  const folderPath = parts.slice(0, -1).join('/') + '/';
  const finalValue = `../${folderPath}`;

  if (!uniquePaths.has(finalValue)) {
    uniquePaths.add(finalValue);
    AUTO_CATALOG_PATHS.push({
      label: `${modulo}: ${carpeta}`,
      value: finalValue,
    });
  }
});

// Lista final usada por el select
const CATALOG_PATHS = [...STATIC_CATALOG_PATHS, ...AUTO_CATALOG_PATHS];

const NAVIGATE_PATHS = [
  // CarBooking
  { label: 'CarBooking: Panel', value: '/menu/car-booking' },
  { label: 'CarBooking: Reservas', value: '/menu/car-booking/reservas' },
  { label: 'CarBooking: Chofer', value: '/menu/car-booking/chofer' },
  { label: 'CarBooking: Recursos Humanos', value: '/menu/car-booking/rh' },
  { label: 'CarBooking: Calendario', value: '/menu/car-booking/calendar' },
  { label: 'CarBooking: Mapas', value: '/menu/car-booking/maps' },

  // LMS
  { label: 'LMS: Panel', value: '/menu/lms' },
  { label: 'LMS: Estudiantes', value: '/menu/lms/estudiantes' },
  { label: 'LMS: Estadisticas', value: '/menu/lms/estadisticas' },
  { label: 'LMS: Dashboard General', value: '/menu/lms/dashboard-general' },
  { label: 'LMS: Progreso', value: '/menu/lms/progreso' },
  { label: 'LMS: Administradores', value: '/menu/lms/administradores' },
  { label: 'LMS: Admin Cursos', value: '/menu/lms/administrar-cursos' },
  { label: 'LMS: Admin Carreras', value: '/menu/lms/administrar-carreras' },
  { label: 'LMS: Lecciones', value: '/menu/lms/lecciones' },
  { label: 'LMS: Cursos Panel', value: '/menu/lms/cursos' },
  { label: 'LMS: Mis Cursos', value: '/menu/lms/mis-cursos' },
  { label: 'LMS: Mis Carreras', value: '/menu/lms/mis-carreras' },
  { label: 'LMS: Mis Certificados', value: '/menu/lms/mis-certificados' },
  { label: 'LMS: Tienda Premios', value: '/menu/lms/tienda-premios' },
  { label: 'LMS: Catalogo Cursos', value: '/menu/lms/catalogo-cursos' },
  { label: 'LMS: Catalogo Carreras', value: '/menu/lms/catalogo-carreras' },
  { label: 'LMS: Asignar Evaluaciones', value: '/menu/lms/asignar-evaluaciones' },
  { label: 'LMS: Ajustes General', value: '/menu/lms/ajustes/general' },

  // Intranet
  { label: 'Intranet: Panel', value: '/menu/intranet' },
  { label: 'Intranet: Comunicación Dashboard', value: '/menu/intranet/comunicacion/dashboard' },
  { label: 'Intranet: Comunicación Noticias', value: '/menu/intranet/comunicacion/noticias' },
  { label: 'Intranet: Comunicación Artículos', value: '/menu/intranet/comunicacion/articulos' },
  { label: 'Intranet: Comunicación Foros', value: '/menu/intranet/comunicacion/foros' },
  { label: 'Intranet: Comunicación Avisos', value: '/menu/intranet/comunicacion/avisos' },
  { label: 'Intranet: Comunicación Buzón', value: '/menu/intranet/comunicacion/buzon' },
  { label: 'Intranet: Comunicación Calendario', value: '/menu/intranet/comunicacion/calendario' },
  { label: 'Intranet: Comunicación Gestor Documentos', value: '/menu/intranet/comunicacion/gestorDocumentos' },
  { label: 'Intranet: Comunicación Encuestas', value: '/menu/intranet/comunicacion/encuestas' },
  { label: 'Intranet: Usuario Dashboard', value: '/menu/intranet/usuario' },
  { label: 'Intranet: Usuario Noticias', value: '/menu/intranet/usuario/noticias' },
  { label: 'Intranet: Usuario Artículos', value: '/menu/intranet/usuario/articulos' },
  { label: 'Intranet: Usuario Foros', value: '/menu/intranet/usuario/foros' },
  { label: 'Intranet: Usuario Avisos', value: '/menu/intranet/usuario/avisos' },
  { label: 'Intranet: Usuario Sugerencias', value: '/menu/intranet/usuario/sugerencias' },
  { label: 'Intranet: Usuario Calendario', value: '/menu/intranet/usuario/calendario' },
  { label: 'Intranet: Usuario Documentos', value: '/menu/intranet/usuario/documentos' },
  { label: 'Intranet: Usuario Encuestas', value: '/menu/intranet/usuario/encuestas' },

  // Sistema
  { label: 'Sistema: Panel Principal', value: '/menu/sistema' },
  { label: 'Sistema: Gestión de Colores', value: '/menu/sistema/colores' },
  { label: 'Sistema: Gestión de Logos', value: '/menu/sistema/logos' },
  { label: 'Sistema: Imágenes del Sistema', value: '/menu/sistema/imagenes' },
  { label: 'Sistema: Diseñador de Temas', value: '/menu/sistema/designer' },
  { label: 'Sistema: Importación Masiva', value: '/menu/sistema/importacion' },

  // RH
  { label: 'RH: Panel Principal', value: '/menu/rh' },
  { label: 'RH: Turnos', value: '/menu/rh/turnos' },
  { label: 'RH: Dias Inhabiles', value: '/menu/rh/dias-inhabiles' },
  { label: 'RH: Empleados', value: '/menu/rh/empleados' },
  { label: 'RH: Puestos', value: '/menu/rh/puestos' },
  { label: 'RH: Area de Negocio', value: '/menu/rh/area-negocio' },

  // General / Otros
  { label: 'General: Panel Principal', value: '/menu' },
  { label: 'General: Roles', value: '/roles' },
  { label: 'General: Login', value: '/login' },
  { label: 'Seguridad: Matriz de Permisos', value: '/menu/seguridad/matriz-permisos' },
];



export default function Modal({
  open,
  mode = 'new',
  data = null,
  onClose,
  onSubmit,
  inline = false,
}) {
  const [form, setForm] = useState(EMPTY);
  const [menuOptions, setMenuOptions] = useState([]);
  const [moduloOptions, setModuloOptions] = useState([]);
  const [recursoOptions, setRecursoOptions] = useState([]);
  const [recursosOpen, setRecursosOpen] = useState(false);
  const [savingRecurso, setSavingRecurso] = useState(false);
  const [alertConfig, setAlertConfig] = useState({ open: false, message: '', title: 'Información', variant: 'info' });

  const triggerAlert = (message, variant = 'error', title = 'Error') => {
    setAlertConfig({ open: true, message, variant, title });
  };

  const [reorderOpen, setReorderOpen] = useState(false); // State for reorder modal

  // ... (existing code)



  // Cargar catálogos (menús padre, módulos, recursos)
  const loadCatalogs = async () => {
    try {
      const [resMenus, resModulos, resRecursos] = await Promise.all([
        axios.get(endpointMenus),
        axios.get(endpointModulos),
        axios.get(endpointRecursos),
      ]);

      const listaMenus = (resMenus.data || []).map((x) => Models.menu(x));
      const listaModulos = (resModulos.data || []).map((x) => Models.moduloSeguridad(x));
      const listaRecursos = (resRecursos.data || []).map((x) => Models.catRecursos(x));

      setMenuOptions(listaMenus);
      setModuloOptions(listaModulos);
      setRecursoOptions(listaRecursos);
    } catch (e) {
      console.error('Error cargando catálogos para el modal de menús', e);
    }
  };

  useEffect(() => {
    if (!open) return;
    loadCatalogs();
  }, [open]);

  // Cargar datos del registro en edición o limpiar en modo new
  useEffect(() => {
    if (mode === 'edit' && data) {
      setForm({
        idMenu: data.idMenu ?? 0,
        idModulo: data.idModulo ?? 0,
        nombre: data.nombre ?? '',
        clave: data.clave ?? '',
        // nivel siempre 1
        nivel: 1,
        idPadre: data.idPadre ?? 0,
        orden: data.orden ?? 0,
        ruta: data.ruta ?? '',
        icono: data.icono ?? '',
        idRecurso: data.idRecurso ?? 0,
        esRaizModulo: !!data.esRaizModulo,
      });
    } else {
      setForm(EMPTY);
    }
  }, [mode, data]);

  const usedRoutes = useMemo(() => {
    const set = new Set();
    menuOptions.forEach((m) => {
      const isCurrent = mode === 'edit' && data && m.idMenu === data.idMenu;
      if (!isCurrent && m.ruta) {
        set.add(m.ruta.trim());
      }
    });
    return set;
  }, [menuOptions, mode, data]);

  // Recursos usados en otros menús
  const usedRecursos = useMemo(() => {
    const set = new Set();
    menuOptions.forEach((m) => {
      const isCurrent = mode === 'edit' && data && m.idMenu === data.idMenu;
      if (!isCurrent && m.idRecurso) {
        set.add(Number(m.idRecurso));
      }
    });
    return set;
  }, [menuOptions, mode, data]);

  // Filtrar y ordenar recursos: solo tipo "Menu" o "Modulo", no usados primero (con ★), luego usados
  const filteredRecursos = useMemo(() => {
    // Primero filtrar solo recursos de tipo "Menu" o "Modulo"
    const menuRecursos = recursoOptions.filter((r) => {
      const tipo = (r.tipo || r.Tipo || '').toLowerCase();
      return tipo === 'menu' || tipo === 'modulo';
    });

    const unused = [];
    const used = [];

    menuRecursos.forEach((r) => {
      if (usedRecursos.has(r.idRecurso)) {
        used.push(r);
      } else {
        unused.push(r);
      }
    });

    const unusedWithStar = unused.map((r) => ({
      ...r,
      displayName: `★ ${r.nombre}`,
    }));

    const usedWithName = used.map((r) => ({
      ...r,
      displayName: r.nombre,
    }));

    return [...unusedWithStar, ...usedWithName];
  }, [recursoOptions, usedRecursos]);

  const filteredRoutes = useMemo(() => {
    // Filtrar por módulo seleccionado (solo catálogos de ese módulo)
    const currentMod = moduloOptions.find((m) => m.idModulo === form.idModulo);
    let modFolder = currentMod ? toPascalCase(currentMod.nombre) : '';

    // Mapeo especial: 'Recursos Humanos' (DB) -> 'RH' (Carpeta)
    if (modFolder.toLowerCase() === 'recursoshumanos') modFolder = 'RH';

    let relevant = CATALOG_PATHS.filter((opt) => {
      // Siempre conservar extras especiales
      if (opt.value === '../' || opt.value.startsWith('/nav')) return true;

      // Si no hay módulo seleccionado, mostrar todos
      if (!modFolder) return true;

      // Solo procesar rutas relativas tipo '../Modulo/...'
      if (!opt.value.startsWith('../')) return true;

      const match = opt.value.match(/^\.\.\/([^/]+)\//); // '../Lms/' -> 'Lms'
      const routeFolder = match ? match[1] : '';
      return routeFolder === modFolder;
    });

    const unused = [];
    const extras = [];
    const used = [];

    relevant.forEach((opt) => {
      if (opt.value === '../' || opt.value.startsWith('/nav')) {
        extras.push(opt);
      } else if (usedRoutes.has(opt.value)) {
        used.push(opt);
      } else {
        unused.push(opt);
      }
    });

    const unusedWithStar = unused.map((opt) => ({
      ...opt,
      label: `★ ${opt.label}`,
    }));

    let final = [...unusedWithStar, ...extras, ...used];

    const currentVal = form.ruta || '';
    const isDefault = currentVal === '../Modulo/Components/Catalogos/Carpeta/';
    if (currentVal && !isDefault && !final.find((x) => x.value === currentVal)) {
      final.unshift({ label: `Actual: ${currentVal}`, value: currentVal });
    }

    return final;
  }, [form.idModulo, moduloOptions, usedRoutes, form.ruta]);

  const usedNavigateRoutes = useMemo(() => {
    const set = new Set();
    menuOptions.forEach((m) => {
      const isCurrent = mode === 'edit' && data && m.idMenu === data.idMenu;
      if (!isCurrent && m.ruta === '/navigate' && m.clave) {
        set.add(m.clave.trim());
      }
    });
    return set;
  }, [menuOptions, mode, data]);

  const filteredNavigateRoutes = useMemo(() => {
    const currentMod = moduloOptions.find((m) => m.idModulo === form.idModulo);

    let modKey = '';
    if (currentMod) {
      const name = currentMod.nombre.toLowerCase();
      if (name.includes('car')) modKey = 'car-booking';
      else if (name.includes('lms')) modKey = 'lms';
      else if (name.includes('intra')) modKey = 'intranet';
      else if (name.includes('rh') || name.includes('recursos')) modKey = 'rh';
    }

    let relevant = NAVIGATE_PATHS.filter((opt) => {
      if (!modKey) return true;
      if (opt.value.includes(`/${modKey}`)) return true;
      if (!opt.value.includes('/menu/')) return true;
      if (opt.value === '/menu') return true;
      return false;
    });

    const unused = [];
    const used = [];

    relevant.forEach((opt) => {
      if (usedNavigateRoutes.has(opt.value)) {
        used.push(opt);
      } else {
        unused.push(opt);
      }
    });

    const unusedWithStar = unused.map((opt) => ({
      ...opt,
      label: `★ ${opt.label}`,
    }));

    let final = [...unusedWithStar, ...used];

    if (form.ruta === '/navigate' && form.clave && form.clave !== 'Catalog.jsx') {
      if (!final.find((x) => x.value === form.clave)) {
        final.unshift({ label: `Actual: ${form.clave}`, value: form.clave });
      }
    }

    return final;
  }, [form.idModulo, moduloOptions, usedNavigateRoutes, form.ruta, form.clave]);

  // Nuevo memo para obtener archivos disponibles en la ruta seleccionada
  const availableFiles = useMemo(() => {
    if (!form.ruta || !form.ruta.startsWith('../') || form.ruta === '../') return [];

    // El path en context se ve como components/... (sin ../)
    // form.ruta se ve como ../Modulo/Components/...
    const searchPath = form.ruta.replace(/^\.\.\//, '');

    return componentFiles.keys()
      .filter(key => {
        const cleanKey = key.replace(/^\.\//, '');
        return cleanKey.startsWith(searchPath);
      })
      .map(key => {
        const parts = key.split('/');
        return parts[parts.length - 1];
      });
  }, [form.ruta]);


  const handleRouteChange = (e) => {
    const newPath = e.target.value;
    let newClave = form.clave;

    if (newPath && newPath.includes('/') && !newPath.startsWith('/nav') && newPath !== '../') {
      const segments = newPath.split('/').filter((s) => s && s !== '..');
      const folder = segments.pop();
      if (folder) {
        newClave = `${folder}Catalog.jsx`;
      }
    }
    setForm({ ...form, ruta: newPath, clave: newClave });
  };

  // Calcular el siguiente número de orden basado en el menú padre
  const calculateNextOrder = useMemo(() => {
    if (!form.idModulo) return 1;

    // Filtrar menús del mismo módulo y mismo padre
    const siblingsMenus = menuOptions.filter((m) => {
      const isCurrent = mode === 'edit' && data && m.idMenu === data.idMenu;
      if (isCurrent) return false; // Excluir el menú actual en modo edición

      return (
        Number(m.idModulo) === Number(form.idModulo) &&
        Number(m.idPadre || 0) === Number(form.idPadre || 0)
      );
    });

    // El siguiente orden es la cantidad de hermanos + 1
    return siblingsMenus.length + 1;
  }, [form.idModulo, form.idPadre, menuOptions, mode, data]);

  // Auto-actualizar el orden cuando cambia el módulo o el padre
  useEffect(() => {
    if (mode === 'new') {
      setForm((prev) => ({ ...prev, orden: calculateNextOrder }));
    }
  }, [calculateNextOrder, mode]);

  if (!open) return null;

  // Menús padre filtrados por módulo seleccionado
  const parentMenuOptions =
    form.idModulo
      ? menuOptions.filter(
        (m) => Number(m.idModulo) === Number(form.idModulo)
      )
      : [];

  // Se llama cuando guardas en el RecursosModal
  const handleSubmitNuevoRecurso = async (recursoForm) => {
    try {
      setSavingRecurso(true);
      const res = await axios.post(endpointRecursos, recursoForm);
      const created = res?.data || {};

      // Debug: Ver la respuesta completa
      console.log('[MenuModal] Respuesta completa del API:', res);
      console.log('[MenuModal] Datos del recurso creado:', created);
      console.log('[MenuModal] Tipo de datos:', typeof created);

      // Extraer el ID del recurso creado - intentar todas las variantes posibles
      let newId = 0;

      // Si la respuesta es directamente un número
      if (typeof created === 'number') {
        newId = created;
      }
      // Si es un objeto, buscar el ID en diferentes propiedades
      else if (typeof created === 'object' && created !== null) {
        newId = created.idRecurso ||
          created.IdRecurso ||
          created.id ||
          created.Id ||
          created.ID ||
          0;
      }

      console.log('[MenuModal] ID extraído del recurso:', newId);

      // Refrescar catálogo de recursos para que aparezca el nuevo
      await loadCatalogs();

      // Seleccionar automáticamente el nuevo recurso en el select
      if (newId && newId > 0) {
        // Usar setTimeout para asegurar que el estado se actualice después del render
        setTimeout(() => {
          setForm((f) => {
            console.log('[MenuModal] Seleccionando recurso con ID:', newId);
            return { ...f, idRecurso: newId };
          });
        }, 100);
      } else {
        console.warn('[MenuModal] ⚠️ No se pudo extraer un ID válido del recurso creado');
      }

      setRecursosOpen(false);
    } catch (e) {
      console.error('[MenuModal] Error al crear recurso:', e);
      triggerAlert('No se pudo crear el recurso.');
    } finally {
      setSavingRecurso(false);
    }
  };



  const Header = (
    <div
      className="roles-topbar"
      style={{
        marginBottom: '0.6rem',
        paddingRight: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: '0 0 auto',
      }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
        <h3 className="roles-title" style={{ marginRight: 0 }}>
          {mode === 'new' ? 'Nuevo menú' : 'Editar menú'}
        </h3>
        {mode === 'edit' && data && (
          <button
            type="button"
            className="btn-action"
            onClick={() => setReorderOpen(true)}
            title="Reordenar los hijos de este menú"
          >
            ⇅ Reordenar Hijos
          </button>
        )}
      </div>
      <button className="roles-btn" onClick={onClose} aria-label="Cerrar">✕</button>
    </div>
  );

  const Body = (
    <div
      style={{
        paddingLeft: '15%',
        paddingRight: 16,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '0.8rem',
        overflowY: 'auto',
        flex: '1 1 auto',
        minHeight: 0,
      }}>

      {/* Módulo como select (nombre visible, idModulo como value) */}
      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Módulo:</label>
        <br /><br />
        <select
          className="infoField"
          value={form.idModulo ?? 0}
          onChange={(e) => {
            const newId = e.target.value ? Number(e.target.value) : 0;
            // al cambiar de módulo, limpiamos idPadre
            setForm((prev) => ({
              ...prev,
              idModulo: newId,
              idPadre: 0,
            }));
          }}
        >
          <option value={0}>Seleccione un módulo…</option>
          {moduloOptions.map((m) => (
            <option key={m.idModulo} value={m.idModulo}>
              {m.nombre}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Nombre:</label>
        <br /><br />
        <input
          className="infoField"
          value={form.nombre}
          onChange={(e) => {
            setForm({ ...form, nombre: e.target.value });
          }}
          maxLength={100}
        />
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>
          {form.ruta === '/navigate' ? 'Ruta destino (Clave):' : 'Clave:'}
        </label>
        <br /><br />
        {form.ruta === '/navigate' ? (
          <select
            className="infoField"
            value={form.clave}
            onChange={(e) => setForm({ ...form, clave: e.target.value })}
          >
            <option value="">Seleccione destino…</option>
            {filteredNavigateRoutes.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        ) : availableFiles.length > 0 ? (
          <select
            className="infoField"
            value={form.clave}
            onChange={(e) => setForm({ ...form, clave: e.target.value })}
          >
            <option value="">Seleccione archivo…</option>
            {availableFiles.map((file) => (
              <option key={file} value={file}>
                {file}
              </option>
            ))}
          </select>
        ) : (
          <input
            className="infoField"
            value={form.clave}
            onChange={(e) => setForm({ ...form, clave: e.target.value })}
            maxLength={50}
          />
        )}
      </div>

      {/* Menú padre como select (clave visible, idMenu como value) */}
      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Menú padre:</label>
        <br /><br />
        <select
          className="infoField"
          value={form.idPadre ?? 0}
          onChange={(e) =>
            setForm({
              ...form,
              idPadre: e.target.value ? Number(e.target.value) : 0,
            })
          }
        >
          <option value={0}>(Sin padre / raíz)</option>
          {parentMenuOptions.map((m) => (
            <option key={m.idMenu} value={m.idMenu}>
              {m.clave}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Orden (auto):</label>
        <br /><br />
        <input
          className="infoField"
          type="number"
          min={1}
          value={form.orden}
          onChange={(e) => setForm({ ...form, orden: Number(e.target.value) || 1 })}
          style={{ backgroundColor: '#f8f9fa' }}
          title="Se calcula automáticamente según los menús hermanos. Puedes ajustarlo manualmente si es necesario."
        />
        <small style={{ display: 'block', marginTop: '4px', color: '#64748b', fontSize: '0.8rem' }}>
          Calculado: {calculateNextOrder} (basado en {menuOptions.filter(m =>
            Number(m.idModulo) === Number(form.idModulo) &&
            Number(m.idPadre || 0) === Number(form.idPadre || 0) &&
            !(mode === 'edit' && data && m.idMenu === data.idMenu)
          ).length} menú(s) hermano(s))
        </small>
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>
          Ruta (path de navegación / catálogo):
        </label>
        <br /><br />
        <select
          className="infoField"
          value={form.ruta}
          onChange={handleRouteChange}
        >
          <option value="">Seleccione ruta…</option>
          {filteredRoutes.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Ícono:</label>
        <br /><br />
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center', width: '75%' }}>
          <input
            className="infoField"
            value={form.icono}
            onChange={(e) => setForm({ ...form, icono: e.target.value })}
            maxLength={100}
            style={{ flex: 1 }}
          />
          <div
            style={{
              width: '40px',
              height: '40px',
              flex: '0 0 40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: '#f1f5f9',
              color: 'var(--color-primary)',
              borderRadius: '8px',
              border: '1px solid #e2e8f0',
              fontSize: '1.2rem'
            }}
            title="Previsualización"
          >
            <i className={iconToFA(form.icono) || 'fa-solid fa-ban'} />
          </div>
        </div>
      </div>

      {/* Recurso como select + botón para crear nuevo recurso */}
      <div>
        <label
          className="roles-title"
          style={{ fontSize: '.95rem', display: 'flex', alignItems: 'center', gap: 8 }}
        >
          Recurso:
          <button
            type="button"
            className="btn-action"
            onClick={() => setRecursosOpen(true)}
            title="Crear nuevo recurso"
            style={{ padding: '2px 8px', lineHeight: 1 }}
          >
            ＋ Recurso
          </button>
        </label>
        <br /><br />
        <select
          className="infoField"
          value={form.idRecurso ?? 0}
          onChange={(e) =>
            setForm({
              ...form,
              idRecurso: e.target.value ? Number(e.target.value) : 0,
            })
          }
        >
          <option value={0}>(Sin recurso asociado)</option>
          {filteredRecursos.map((r) => (
            <option key={r.idRecurso} value={r.idRecurso}>
              {r.displayName}
            </option>
          ))}
        </select>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem' }}>
        <br /><br />
        <input
          id="chkRaiz"
          type="checkbox"
          checked={!!form.esRaizModulo}
          onChange={(e) => setForm({ ...form, esRaizModulo: e.target.checked })}
        />
        <label htmlFor="chkRaiz" className="roles-title" style={{ fontSize: '.95rem' }}>
          Es raíz del módulo
        </label>
      </div>
    </div>
  );

  const Footer = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '.6rem',
        marginTop: '.8rem',
        paddingRight: 16,
        flex: '0 0 auto',
      }}
    >
      <button className="btn-cancel" onClick={onClose}>Cancelar</button>
      <button
        className="btn-action"
        onClick={() => onSubmit(form, mode)}
        disabled={!form.nombre?.trim() || !form.idModulo}
      >
        {mode === 'new' ? 'Guardar' : 'Actualizar'}
      </button>
    </div>
  );

  if (inline) {
    return (
      <div className="roles-inline-card" style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
        {Header}
        {Body}
        {Footer}

        {/* Modal de Recursos embebido */}
        <RecursosModal
          open={recursosOpen}
          mode="new"
          onClose={() => setRecursosOpen(false)}
          onSubmit={handleSubmitNuevoRecurso}
        />
        {savingRecurso && (
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.1)' }} />
        )}

        {/* Modal de Reordenamiento */}
        {reorderOpen && (
          <MenuReorderModal
            open={reorderOpen}
            idMenuPadre={data ? data.idMenu : 0}
            onClose={() => setReorderOpen(false)}
            onSuccess={() => {
              // Opcional: Recargar si fuera necesario, o dejar que el usuario recargue
            }}
          />
        )}
      </div>
    );
  }

  return (
    <div
      className="roles-confirm-overlay"
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15,23,42,.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        zIndex: 1000,
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
    >
      <div
        className="roles-confirm-card"
        style={{
          width: 'min(720px, 96vw)',
          maxHeight: '85vh',
          background: '#fff',
          borderRadius: 12,
          boxShadow: '0 10px 30px rgba(0,0,0,.25)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {Header}
        {Body}
        {Footer}
      </div>

      {/* Modal de Recursos */}
      <RecursosModal
        open={recursosOpen}
        mode="new"
        onClose={() => setRecursosOpen(false)}
        onSubmit={handleSubmitNuevoRecurso}
      />
      {savingRecurso && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.1)' }} />
      )}

      <AlertDialog
        open={alertConfig.open}
        title={alertConfig.title}
        message={alertConfig.message}
        variant={alertConfig.variant}
        onClose={() => setAlertConfig({ ...alertConfig, open: false })}
      />
      {reorderOpen && (
        <MenuReorderModal
          open={reorderOpen}
          idMenuPadre={data ? data.idMenu : 0}
          onClose={() => setReorderOpen(false)}
        />
      )}
    </div>
  );
}
